/**
 * Noms canoniques des statuts de vol.
 * Les ids de `flight_status` dépendent de la course (chaque course possède ses
 * propres statuts) : ne jamais coder un id en dur, seulement un nom.
 */
export const FLIGHT_STATUS_NAMES = {
    PREVIEW: "Preview",
    VALIDATED: "Validated",
    CANCELLED: "Cancelled",
    ARCHIVED: "Archived"
}

const planning_passengers: Array<any> = [
    {
        name: "DATE",
        field: "date"
    }
]


export const getFieldsPlanningByRole = (role: string) => {
    switch(role) {
        case "PASSENGERS":
            return planning_passengers
            break;
        default:
            break;
    }
}
